import { MerchantAutoenrollmentInitRepository } from '@/AutoEnrollment/domain'
import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import { getMerchantAutoenrollmentInit } from '@/Shared/infrastructure/endpoints'

export function createApiMerchantAutoenrollmentInitRepository(): MerchantAutoenrollmentInitRepository {
  return new ApiMerchantAutoenrollmentInitRepository()
}

export class ApiMerchantAutoenrollmentInitRepository
  implements MerchantAutoenrollmentInitRepository
{
  async GetMerchantAutoenrollmentInit(): Promise<HttpModel<boolean>> {
    return await axiosFetch(getMerchantAutoenrollmentInit, HttpMethod.POST)
  }
}
